export const formatISOToLocalDate = (
  isoString: string | Date | null | undefined,
  format: "date" | "datetime" | "time" = "datetime"
): string => {
  if (!isoString) return "-";

  try {
    const date = new Date(isoString);

    if (isNaN(date.getTime())) {
      return "Invalid date";
    }

    switch (format) {
      case "date":
        return date.toLocaleDateString();
      case "time":
        return date.toLocaleTimeString();
      case "datetime":
      default:
        return date.toLocaleString();
    }
  } catch (error) {
    console.warn("Error formatting date:", error);
    return "Invalid date";
  }
};

export const getRelativeTime = (
  isoString: string | Date | null | undefined
): string => {
  if (!isoString) return "-";

  try {
    const date = new Date(isoString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();

    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (minutes < 1) return "Just now";
    if (minutes < 60) return `${minutes} min ago`;
    if (hours < 24) return `${hours} hr ago`;
    if (days < 7) return `${days} day${days > 1 ? "s" : ""} ago`;

    return formatISOToLocalDate(isoString, "date");
  } catch (error) {
    return "-";
  }
};
